import { useState } from "react";
import { HexColorPicker } from "react-colorful";
import "./ColorPopover.css";

const SWATCHES = [
  "#0f172a", "#64748b", "#dc2626", "#ea580c",
  "#ca8a04", "#16a34a", "#0891b2", "#2563eb",
  "#6366f1", "#8b5cf6", "#db2777", "#ffffff",
];

export default function ColorPopover({ value, onChange, onClose }) {
  const [custom, setCustom] = useState(value || "#6366f1");
  return (
    <div className="color-popover">
      <div className="color-swatches">
        {SWATCHES.map((c) => (
          <button
            key={c}
            type="button"
            className="color-swatch"
            style={{ background: c, outline: c === value ? "2px solid #6366f1" : undefined }}
            onClick={() => { onChange(c); onClose?.(); }}
            title={c}
          />
        ))}
      </div>
      <div className="color-custom">
        <HexColorPicker color={custom} onChange={(c) => { setCustom(c); onChange(c); }} />
        <input
          type="text"
          value={custom}
          onChange={(e) => { setCustom(e.target.value); onChange(e.target.value); }}
          className="color-hex-input"
          maxLength={7}
        />
      </div>
    </div>
  );
}
